import { jsxs, jsx } from "react/jsx-runtime";
import { Box, Paragraph, TextButton } from "@zillow/constellation-10";
import { IconChevronUpOutline, IconChevronDownOutline } from "@zillow/constellation-icons";
import PropTypes from "prop-types";
import { useState, useMemo } from "react";
import { getDTIMessageParts } from "./DTICalculator.utils.esm.js";
const MAX_GOOD_DTI_RATIO = 36;
const DTIMessage = ({
  value,
  defaultExpanded
}) => {
  const [expanded, setExpanded] = useState(defaultExpanded);
  const {
    result,
    description
  } = useMemo(() => getDTIMessageParts(value, expanded), [value, expanded]);
  const onClick = (e) => {
    e == null ? void 0 : e.preventDefault();
    setExpanded(!expanded);
  };
  return /* @__PURE__ */ jsxs(Box, { css: {
    margin: "auto",
    maxWidth: "400px"
  }, children: [
    /* @__PURE__ */ jsxs(Paragraph, { children: [
      /* @__PURE__ */ jsxs("strong", { children: [
        " ",
        result,
        " "
      ] }),
      description
    ] }),
    /* @__PURE__ */ jsx(Box, { css: {
      display: value > MAX_GOOD_DTI_RATIO ? "block" : "none",
      paddingTop: "tighter",
      paddingBottom: "default",
      paddingInline: "0",
      margin: "auto",
      textAlign: "center",
      md: {
        display: "none"
      }
    }, children: /* @__PURE__ */ jsx(TextButton, { onClick, "aria-expanded": expanded, icon: expanded ? /* @__PURE__ */ jsx(IconChevronUpOutline, { style: {
      width: "16px",
      height: "16px"
    } }) : /* @__PURE__ */ jsx(IconChevronDownOutline, { style: {
      width: "16px",
      height: "16px"
    } }), iconPosition: "end", children: expanded ? "Read less" : "Read more" }) })
  ] });
};
DTIMessage.propTypes = {
  value: PropTypes.number,
  defaultExpanded: PropTypes.bool
};
export {
  DTIMessage,
  DTIMessage as default
};
